<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <template v-if="isEditarForm">
        <div class="table-action-box" v-bind="attrs" v-on="on">
          <v-icon small>mdi-pencil</v-icon>
          <span class="table-action-label">Editar</span>
        </div>
      </template>
      <template v-else>
        <v-btn small color="primary" class="pasta-add-btn" v-bind="attrs" v-on="on">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </template>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">{{ isEditarForm ? 'mdi-folder-edit' : 'mdi-folder-plus' }}</v-icon>
        <div>
          <span class="sc-modal__title">{{ isEditarForm ? 'Editar pasta' : 'Nova pasta' }}</span>
          <span class="sc-modal__subtitle">Organize as colaborações em pastas</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Nome da pasta</label>
          <v-text-field
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Ex: Aprovados, Favoritos..."
            v-model="dsc_nome_pasta"
            hide-details="auto"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="isEditarForm ? editarPasta() : inserirPasta()"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          {{ isEditarForm ? 'Atualizar' : 'Salvar' }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from '@/services/api';

export default {
  name: "ModalAdicionarOuEditarPastas",
  props: {
    getPastas: Function,
    editFormData: Object,
    isEditarForm: Boolean,
  },
  data() {
    return {
      loading: false,
      dsc_nome_pasta: "",
      dialog: false,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.seedForm();
    },
  },
  created() {
    this.seedForm();
  },
  methods: {
    seedForm() {
      this.dsc_nome_pasta = this.isEditarForm && this.editFormData
        ? this.editFormData.dsc_nome_pasta
        : "";
    },
    async inserirPasta() {
      try {
        this.loading = true;

        if (this.dsc_nome_pasta.trim() === '') {
          return this.$toast.error('Insira o nome da pasta.');
        }

        const payload = {
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          dsc_nome_pasta: this.dsc_nome_pasta,
        };

        const response = await apiClient.post('/pastas/inserirPasta', payload);

        if (response.status === 200) {
          this.$toast.success('Pasta criada com sucesso.');
          await this.getPastas();
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao criar pasta.');
      } finally {
        this.loading = false;
      }
    },
    async editarPasta() {
      try {
        this.loading = true;

        if (this.dsc_nome_pasta.trim() === '') {
          return this.$toast.error('Insira o nome da pasta.');
        }

        const payload = {
          cod_pasta: this.editFormData.cod_pasta,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          dsc_nome_pasta: this.dsc_nome_pasta,
        };

        const response = await apiClient.post('/pastas/editarPasta', payload);

        if (response.status === 200) {
          this.$toast.success('Pasta atualizada com sucesso.');
          await this.getPastas();
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao editar pasta.');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.dsc_nome_pasta = this.isEditarForm ? this.editFormData.dsc_nome_pasta : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.pasta-add-btn {
  text-transform: none;
  font-weight: var(--sc-weight-semi);
  letter-spacing: 0;
  border-radius: var(--sc-radius-md);
}
</style>
